import { faTimes, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../components/Input";
import { useState } from "react";
import { api } from "../../services/api";
import { useCache } from "../../hooks/useCache";
import { checkToken } from "../../utils/checkToken";
import { useNavigate } from "react-router-dom";
import { Load } from "../../components/Load";

import "./style.css";

type IProps = {
  closeModal: () => void;
};

export function ModalAlteraSenha({ closeModal }: IProps) {
  const navigate = useNavigate();

  const { token, refreshToken, usuario, cacheTokens } = useCache();
  const cacheError = { refreshToken, usuario, cacheTokens };

  const [loading, setLoading] = useState(false);

  const [novaSenha, setNovaSenha] = useState("");

  const handleSalvar = async () => {
    if (!token) return;

    setLoading(true);

    const rsCheckToken = await checkToken(cacheError, token);
    if (rsCheckToken.redirectLogin) navigate("/login");

    await api
      .post(`users/resetPassword?token=${refreshToken}`, {
        senha: novaSenha,
      })
      .then(() => {
        alert("Senha alterada com sucesso!");
        closeModal();
      })
      .catch((err) => {
        console.log(err);        
        if (err.response.status !== 401) alert(err.response.data.message);
      });
  };

  return (
    <div className="modalAlteraSenha">
      <div className="title">
        <p>Altera Senha</p>
        <FontAwesomeIcon
          icon={faTimes}
          style={{ cursor: "pointer" }}
          onClick={closeModal}
        />
      </div>
      <div className="body">
        {loading && (
          <Load
            txtLoading="Alterando senha..."
            options={{ height: 120, width: 120 }}
          />
        )}

        {!loading && (
          <>
            <div className="info">
              <h4>Nova Senha</h4>
            </div>

            <div className="divFormModal">
              <Input
                autoFocus
                mask="none"
                value={novaSenha}
                inputMaskChange={setNovaSenha}
                placeholder="Nova Senha..."
                type="password"
              />

              <button className="btn-green" onClick={handleSalvar}>
                <FontAwesomeIcon icon={faSave} /> SALVAR NOVA SENHA
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
